// 用于初始化所有的局部参数，结合到datamodel中返回后端进行模拟
export const initObjectProperty = function(dataModel) {
  const entrances = [];
  const shops = [];
  const shopsExcluded = [];
  const foodAndBeverage = [];
  const cinema = [];
  const spotZone = [];
  //先分类所有的数据
  dataModel.forEach(dataElement => {
    if (dataElement.dataElementProperty.element_type === "entrance") {
      entrances.push(dataElement);
    } else if (dataElement.dataElementProperty.element_type === "shop") {
      shops.push(dataElement);
    } else if (dataElement.dataElementProperty.element_type === "food") {
      foodAndBeverage.push(dataElement);
    } else if (dataElement.dataElementProperty.element_type === "cinema") {
      cinema.push(dataElement);
    } else if (dataElement.dataElementProperty.element_type === "spot_zone") {
      spotZone.push(dataElement);
    } else if (dataElement.dataElementProperty.element_type === "shop_excluded") {
      shopsExcluded.push(dataElement);
    }
  });
  //逐个处理其中的属性
  if (entrances.length > 0) {
    entrances.forEach(item => {
      const index = entrances.indexOf(item);
      item.dataElementProperty.element_custom_semantics = {
        objectType: "Entrance",
        entranceIndex: index,
        agentCount: 100,
        description: "出入口", 
        walkAroundAgentPercentage: 5,
        passingByAgentPercentage: 25,
        shoppingAgentPercentage: 70,
        plannedAgentPercentage: 0
      };
    });
  }
  if (shops.length > 0) {
    shops.forEach(item => {
      const index = shops.indexOf(item);
      item.dataElementProperty.element_custom_semantics = {
        objectType: "Shop",
        shopIndex: index,
        shopType: 1
      };
    });
  }
  if (shopsExcluded.length > 0) {
    shopsExcluded.forEach(item => {
      const index = shopsExcluded.indexOf(item);
      item.dataElementProperty.element_custom_semantics = {
        objectType: "Other",
        shopIndex: index,
        shopType: 5
      };
    });
  }
  if (foodAndBeverage.length > 0) {
    foodAndBeverage.forEach(item => {
      const index = foodAndBeverage.indexOf(item);
      item.dataElementProperty.element_custom_semantics = {
        objectType: "F&B",
        shopIndex: index,
        shopType: 2
      };
    });
  }
  if (cinema.length > 0) {
    cinema.forEach(item => {
      const index = cinema.indexOf(item);
      item.dataElementProperty.element_custom_semantics = {
        objectType: "Cinema",
        shopIndex: index,
        shopType: 4
      };
    });
  }
  if (spotZone.length > 0) {
    spotZone.forEach(item => {
      const index = spotZone.indexOf(item);
      item.dataElementProperty.element_custom_semantics = {
        objectType: "Art Space & Spot Zone",
        shopIndex: index,
        shopType: 3
      };
    });
  }
};

export const dataModelAssemble = function(
  dataModel,
  globalParams,
  project_name
) {
  const postDataModel = {
    model_id: 0,
    model_name: project_name,
    model_elements: []
  };
  dataModel.forEach(dataElement => {
    postDataModel.model_elements.push(dataElement.dataElementProperty);
  });
  return [globalParams, postDataModel]
};
